import { createSelector } from 'reselect';
import { getLatestActivitySet } from './getLatestActivitySet';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

const getWorkOrderId = createSelector(
  [getLatestActivitySet, getCurrentWorkOrderOp, getPostLaborUpdatesOnNats],
  (activitySet, currentWorkOrderOp, natsFlowEnabled) => {
    // NATS flow: get work order ID from the work order operation
    if (natsFlowEnabled && currentWorkOrderOp) {
      return currentWorkOrderOp.workOrderId;
    }

    // Standard flow: get from activity set
    return activitySet.workOrderId;
  }
);

export { getWorkOrderId };
